import React from 'react'
import { Link } from 'react-router'
import sortBy from 'lodash/sortBy'
import moment from 'moment'
import DocumentTitle from 'react-document-title'
import { prefixLink } from 'gatsby-helpers'
import access from 'safe-access'
import { config } from 'config'
import SitePost from '../components/SitePost'
import SiteSidebar from '../components/SiteSidebar'
import Header from '../components/Header'
import Footer from '../components/Footer'

class SiteIndex extends React.Component {
    render() {

      const {route} = this.props
      const post = route.page.data
      const path = route.page.path;

        const pageLinks = []
        // Sort pages.
        const sortedPages = sortBy(this.props.route.pages, (page) => access(page, 'data.date')
        ).reverse()
        sortedPages.forEach((page) => {
            if (access(page, 'file.ext') === 'md' && access(page, 'data.layout') === 'post') {
                const title = access(page, 'data.title') || page.path
                const description = access(page, 'data.description')
                const datePublished = access(page, 'data.date')
                const category = access(page, 'data.category')

                if (pageLinks.length < 4) {
                  pageLinks.push(
                    <Link className='readmore' to={ prefixLink(page.path) }>
                      <div className='blog-post sleek-button'>
                        <time dateTime={ moment(datePublished).format('MMMM D, YYYY') }>
                          { moment(datePublished).format('MMMM YYYY') }
                        </time>
                        <span style={ {    padding: '5px'} }></span>
                        <span className='blog-category'>{ category }</span>
                        <h3>{ title }</h3>
                      </div>
                    </Link>
                  );
                }
            }
        })

        return (
            <DocumentTitle title={ config.siteTitle }>
              <div className="home view">
                <Header {...this.props}/>
                <div className='content'>
                  <div className='main'>
                    <div className='main-inner'>
                      <section className="about section-excerpt">
                        <div className="details">
                          <h4><i className="em em-wave jiggle"></i> Hi there. Nice to see you.</h4>
                          <p>I'm Husam Machlovi, a maker and writer from NYC.</p>
                          <p>By day, I run With Pulp: A small, remote design and development studio. <a className="highlight" href="/work" title="work">Learn more here</a>. At night, I teach a product design course for the City University of New York.</p>
                          <p>I write a lot, and post thoughts and poetry on <a className="highlight" target="blank" href="https://medium.com/@Husam" title="Husam, Medium" target="blank">Medium</a>.</p>
                          <p>To discover more about me and what I'm up to currently, see <a className="highlight" href="/now" title="What I'm up to now">my now page</a>.</p>
                          <h4>Oh and also:</h4>
                          <p>I enjoy finding a different point of view <i className="em em-sunglasses"></i>.</p>
                          <p>Lately, my guiding creative principle has been to reduce form and content to their essence.</p>
                          <p>Avid <a className="highlight" href="/reading" title="reading">reader</a>, <a className="highlight" href="/gaming" title="gaming">gamer</a> and guitarist.</p>
                          <p>Every now and then, I send out an email with a few things I'm enjoying. You can <a className="highlight" href="https://husammachlovi.us7.list-manage.com/subscribe?u=d2dfcf7ddc2440565bdc763b9&id=6ff57e103f" title="newsletter subscription">subscribe to that here</a>.</p>
                          <p>If you'd like to get in touch, <a className="highlight" href="/contact">reach out here</a>. I'd love to connect with you! <i className="em em-handshake"></i></p>
                          <p className="closer"><em>This site was handmade with <i className="fa fa-heart heartbeat" aria-hidden="true"></i> and is built on GatsbyJS. Latest update: October 15, 2018</em></p>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </DocumentTitle>
        )
    }
}

SiteIndex.propTypes = {
    route: React.PropTypes.object,
}

export default SiteIndex



// WEBPACK FOOTER //
// ./index.jsx